<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="Members" [backWithParams]="true">
  <ng-template #addButton>
    <div class="booking_sectionkl">
      <div class="Create_header_btn">
        <button mat-icon-button color="primary" (click)="addmember()"> <mat-icon>add</mat-icon></button>
      </div>
    </div>
  </ng-template>
</sm-title-bar>


<div class="chip_cont">
    <div class="flat_open">
  <mat-chip-listbox aria-label="Fish selection" class="mb-1">
    <mat-chip style="margin-right: 10px;" [ngClass]="{ selected: selectedValue == '1' }" (click)="changeChip('1')">
      All
    </mat-chip>
  </mat-chip-listbox>

  <mat-chip-listbox aria-label="Fish selection" class="mb-1">
    <mat-chip style="margin-right: 10px;" [ngClass]="{ selected: selectedValue == '2' }" (click)="changeChip('2')">
      With dues   
    </mat-chip>
  </mat-chip-listbox>
  <mat-chip-listbox aria-label="Fish selection" class="mb-1">
    <mat-chip [ngClass]="{ selected: selectedValue == '0' }" (click)="changeChip('0')">
      Ex members
    </mat-chip>
  </mat-chip-listbox>
</div>
    <div class="" *ngIf="isOwner">
      <button mat-icon-button [matMenuTriggerFor]="menu2" aria-label="Example icon-button with a menu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu2="matMenu">
  <button mat-menu-item (click)="openautoinvoice()">
    <mat-icon>settings</mat-icon>
    <span>Membership setting</span>
  </button>
</mat-menu>
    </div>
</div>

<div style="margin-bottom: 10px;" *ngIf="!loader">
  <div class="search-field">
    <mat-form-field appearance="outline" class="me-2">
      <mat-label>{{ 'customers.search_label' | translate }}</mat-label>
      <input [formControl]="searchString" matInput placeholder="{{ 'customers.search_placeholder' | translate }}"
        (keyup)="searchServiceData()" />
      <button mat-button *ngIf="!searchString.value" matSuffix aria-label="Clear">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-button *ngIf="searchString.value" matSuffix aria-label="Clear" (click)="reset()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <!-- <div class="rounded-3 bg-light" *ngIf="!loader && membersData.length > 0">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="membersData" [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate" [showPagination]="true" [showImageColumn]="true" [imageTemplate]="image"
      [itemsPerPage]="25">
    </sm-data-table>
  </div> -->
</div>

<!-- data showing -->
<div class="row" *ngIf="!loader">
  <div class="col-sm-6 col-md-6 col-12" *ngFor="let data of membersData">
    <div class="plan-card" style="position: relative;" >
      <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options"
        style="position: absolute; right: 15px; top: 20px;">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu2="matMenu">
        <button mat-menu-item (click)="goviewdetails(data)">
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>View details</span>
        </button>
        <button mat-menu-item (click)="createInvoiceForEnrolled(data)"
          *ngIf="(selectedValue == '1' || selectedValue == '2') && getInvoiceAccess(data.service_mode) ">
          <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
          <span>Create membership invoice</span>
        </button>
        <!-- <button mat-menu-item (click)="openAllInvoices(data)">
          <mat-icon class="material-icons-outlined">receipt</mat-icon>
          <span>See all payments</span>
        </button> -->
        <button mat-menu-item (click)="openDueInvoices(data)">
          <mat-icon class="material-icons-outlined">pending_actions</mat-icon>
          <span>See due payments</span>
        </button>
      
        <!-- <button mat-menu-item (click)="openViewAttendance(data)" *ngIf="isEntityIndividual == '1'">
          <mat-icon class="material-icons-outlined">fact_check</mat-icon>
          <span>View attendance</span>
        </button> -->
        <button mat-menu-item (click)="openPaymentIntimation(data)" *ngIf="data.total_due > 0 && isOwner">
          <mat-icon class="material-icons-outlined">share</mat-icon>
          <span>Send payment intimation</span>
        </button>
        <button mat-menu-item (click)="openmarkabsent(data)" *ngIf="isEntityIndividual == '1' && selectedValue != '0'">
          <mat-icon class="material-icons-outlined">disabled_by_default</mat-icon>
          <span>Mark absent</span>
        </button>
      
        <!-- <button mat-menu-item (click)="updateEnrolledMemberMembershipStatus(data,2)"
          *ngIf="selectedValue == '1' || selectedValue == '2'">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>Cancel membership</span>
        </button> -->
        <!-- <button mat-menu-item (click)="updateEnrolledMemberMembershipStatus(data,1)" *ngIf=" selectedValue == '0'">
          <mat-icon class="material-icons-outlined">check_circle</mat-icon>
          <span> Revive membership</span>
        </button> -->
        <!-- <button mat-menu-item (click)="deleteMember(data)">
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span> Delete member</span>
        </button> -->
      </mat-menu>
      <div class="d-flex align-items-center">
        <div style="position: relative; flex-shrink: 0;">
          <div class="booking-initial" *ngIf="!data.image_thumb_url || data.image_thumb_url == 'null'">{{data.name.slice(0,1).toUpperCase()}}</div>
          <div *ngIf="data.image_thumb_url && data.image_thumb_url != 'null'" class=""
          style="position: relative; ">
          <img [src]="data.image_thumb_url != null 
            && data.image_thumb_url != 'null'
            && data.image_thumb_url != '' ? data.image_thumb_url : './assets/images/photo.png'" onerror="this.src='../../../../assets/images/user-avatar.svg'" alt=""
            class="img-fluid rounded-circle booking-initial-img"
            style="width: 50px; height: 50px; object-fit: cover; object-position: center;">
          </div>
          <div class="error_ioer" *ngIf="data.dispute_status == 2">
          <mat-icon>error</mat-icon>
          </div>
        </div>
        <div class="m-2 clskdf">
          <h2 class="plan-title"> {{ data.name }}</h2>
          <p class="plan-info">
            <span class="value">{{data.member_phone}}</span>,
            <span class="value">{{data.gender}}</span>
          
          </p>
        
        </div>
            </div>

            <div class="afasf">
              <p>  <span class="value">{{data.s_mode}},</span> <span class="label"> Due: </span> <span class="value">{{data.currency_symbol}}{{data.total_due.toFixed(2)}}</span></p>
              <!-- <p class="plan-info">
                <span class="label">Due: </span> <span class="value">{{data.currency_symbol}}{{data.total_due}}</span>
              </p> -->
              <p class="plan-cost my-2">
                <span class="label">Last payment: </span> <span class="value">{{data.last_payment_date | date}}</span>
              </p>
            </div>
      <!-- <p class="plan-cost">
        <span class="value">{{ data.bookingType }}</span>,
        <span class="label">Assigned to: </span><span class="value">{{ data.employee_name }} </span>
      </p> -->
    </div>
  </div>
</div>


<!-- <div style="margin-bottom: 10px;" *ngIf="!loader">
  <div class="search-field">
    <mat-form-field appearance="outline" class="me-2">
      <mat-label>{{ 'customers.search_label' | translate }}</mat-label>
      <input [formControl]="searchString" matInput placeholder="{{ 'customers.search_placeholder' | translate }}"
        (keyup)="searchServiceData()" />
      <button mat-button *ngIf="!searchString.value" matSuffix mat-icon-button aria-label="Clear">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-button *ngIf="searchString.value" matSuffix mat-icon-button aria-label="Clear" (click)="reset()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="rounded-3 bg-light" *ngIf="!loader && membersData.length > 0">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="membersData" [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate" [showPagination]="true" [showImageColumn]="true" [imageTemplate]="image"
      [itemsPerPage]="25">
    </sm-data-table>
  </div>
</div> -->


<ng-template #menuTemplate let-rowvalue>
  <!-- (click)="customerviewdetails(rowvalue)" -->
  <button mat-menu-item (click)="goviewdetails(rowvalue)">
    <mat-icon class="material-icons-outlined">info</mat-icon>
    <span>View details</span>
  </button>
  <button mat-menu-item (click)="createInvoiceForEnrolled(rowvalue)"
    *ngIf="selectedValue == '1' || selectedValue == '2' ">
    <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
    <span>Create membership invoice</span>
  </button>
  <button mat-menu-item (click)="openAllInvoices(rowvalue)">
    <mat-icon class="material-icons-outlined">pending_actions</mat-icon>
    <span>See all payments</span>
  </button>
  <button mat-menu-item (click)="openDueInvoices(rowvalue)">
    <mat-icon class="material-icons-outlined">mail</mat-icon>
    <span>See due payments</span>
  </button>

  <button mat-menu-item (click)="openViewAttendance(rowvalue)" *ngIf="isEntityIndividual == '1'">
    <mat-icon class="material-icons-outlined">fact_check</mat-icon>
    <span>View attendance</span>
  </button>
  <button mat-menu-item (click)="openmarkabsent(rowvalue)" *ngIf="isEntityIndividual == '1'">
    <mat-icon class="material-icons-outlined">disabled_by_default</mat-icon>
    <span>Mark absent</span>
  </button>

  <button mat-menu-item (click)="openPaymentIntimation(rowvalue)" *ngIf="selectedValue == '0' || selectedValue == '2'">
    <mat-icon class="material-icons-outlined">mail</mat-icon>
    <span>Send payment intimation</span>
  </button>
  <button mat-menu-item (click)="updateEnrolledMemberMembershipStatus(rowvalue,2)"
    *ngIf="selectedValue == '1' || selectedValue == '2'">
    <mat-icon class="material-icons-outlined">cancel</mat-icon>
    <span>Cancel membership</span>
  </button>
  <button mat-menu-item (click)="updateEnrolledMemberMembershipStatus(rowvalue,1)" *ngIf=" selectedValue == '0'">
    <mat-icon class="material-icons-outlined">check_circle</mat-icon>
    <span> Revive membership</span>
  </button>
  <button mat-menu-item (click)="deleteMember(rowvalue)">
    <mat-icon class="material-icons-outlined">delete</mat-icon>
    <span> Delete member</span>
  </button>
</ng-template>

<ng-template #image let-objValue>
  <div style="position: relative;">
    <img [src]="
        objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
          ? objValue['image_thumb_url']
          : './assets/images/user-avatar.svg'
      " class="img-fluid rounded-circle" style="border: 1px solid lightgray;" />
    <div class="error_ioer" *ngIf="objValue['dispute_status'] == 2">
      <mat-icon>error</mat-icon>
    </div>
  </div>
</ng-template>
<!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->

<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="!loader && membersData.length == 0">
  <div class="row">
    <div class="col-sm-4 col-md-4 col-12" *ngIf="selectedValue == '1'">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/members-dues.jpg">
            </div>
            <mat-card-title>No member to show.</mat-card-title>
            <mat-card-content>It seems like you haven't started on-boarding members to your business. Start adding here
              and manage professionally.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="addmember()">
                <mat-icon>add</mat-icon>
                Add member
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    
    <div class="col-sm-4 col-md-4 col-12" *ngIf="selectedValue == '2'">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/members-dues.jpg">
            </div>
            <mat-card-title>No member with dues.</mat-card-title>
            <mat-card-content>The members with unpaid invoices and dues in payments, will show here. Apart from the due
              data and other information, you can send them payment intimation too.
            </mat-card-content>
            <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>add</mat-icon>
                     Add member
                  </button>
               </div> -->
          </div>
        </mat-card>
      </div>
    </div>
    
    <div class="col-sm-4 col-md-4 col-12" *ngIf="selectedValue == '0'">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/members-dues.jpg">
            </div>
            <mat-card-title>No ex member to show.</mat-card-title>
            <mat-card-content>The members who are no longer associated with this business, will appear here. You can get
              their details, contact them, send them personalized message or offers.
            </mat-card-content>
            <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>add</mat-icon>
                     Add member
                  </button>
               </div> -->
          </div>
        </mat-card>
      </div>
    </div>
     <div class="col-sm-4 col-md-4 col-12" *ngIf="selectedValue == '1'">
               <div class="dashboard_new">
                <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/all-members.svg">
                 </div>
                 <mat-card-title>How to manage members?</mat-card-title>
                         <mat-card-content> Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> to manage membership in your business. You can check this video as well to get step by step help. 

                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
    <div class="col-sm-4 col-md-4 col-12">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/helpsupport.png">
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content>For any difficulties in adding a new member or if there's any issue with member data,
              contact our support team.

            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="opencontact()">
                <mat-icon>support_agent</mat-icon>
                Contact support
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<!-- placeholder html end -->